/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClipReportSummaryV2ChartBarChart,
    ClipReportSummaryV2ChartBarChartFromJSON,
    ClipReportSummaryV2ChartBarChartFromJSONTyped,
    ClipReportSummaryV2ChartBarChartToJSON,
} from './ClipReportSummaryV2ChartBarChart';
import {
    ClipReportSummaryV2ChartPieChart,
    ClipReportSummaryV2ChartPieChartFromJSON,
    ClipReportSummaryV2ChartPieChartFromJSONTyped,
    ClipReportSummaryV2ChartPieChartToJSON,
} from './ClipReportSummaryV2ChartPieChart';

/**
 * 
 * @export
 * @interface ArticlePastSearchReportChart
 */
export interface ArticlePastSearchReportChart {
    /**
     * 
     * @type {Array<ClipReportSummaryV2ChartBarChart>}
     * @memberof ArticlePastSearchReportChart
     */
    barChart: Array<ClipReportSummaryV2ChartBarChart>;
    /**
     * 
     * @type {Array<ClipReportSummaryV2ChartPieChart>}
     * @memberof ArticlePastSearchReportChart
     */
    pieChart: Array<ClipReportSummaryV2ChartPieChart>;
}

export function ArticlePastSearchReportChartFromJSON(json: any): ArticlePastSearchReportChart {
    return ArticlePastSearchReportChartFromJSONTyped(json, false);
}

export function ArticlePastSearchReportChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchReportChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barChart': ((json['bar_chart'] as Array<any>).map(ClipReportSummaryV2ChartBarChartFromJSON)),
        'pieChart': ((json['pie_chart'] as Array<any>).map(ClipReportSummaryV2ChartPieChartFromJSON)),
    };
}

export function ArticlePastSearchReportChartToJSON(value?: ArticlePastSearchReportChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bar_chart': ((value.barChart as Array<any>).map(ClipReportSummaryV2ChartBarChartToJSON)),
        'pie_chart': ((value.pieChart as Array<any>).map(ClipReportSummaryV2ChartPieChartToJSON)),
    };
}

